var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 38H18C18 38.855 18 40.4 18 40.4C18 43.714 20.686 46.4 24 46.4C27.314 46.4 30 43.714 30 40.4C30 40.4 30 38.855 30 38Z",
    fill: "#8D6E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21C36 14.373 30.627 9 24 9C17.373 9 12 14.373 12 21C12 28 18 33 18 36.8V38H30V36.8C30 33 36 28 36 21Z",
    fill: "#EE8003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23C44.1046 23 45 22.1046 45 21C45 19.8954 44.1046 19 43 19C41.8954 19 41 19.8954 41 21C41 22.1046 41.8954 23 43 23Z",
    fill: "#EE8003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 23C6.10457 23 7 22.1046 7 21C7 19.8954 6.10457 19 5 19C3.89543 19 3 19.8954 3 21C3 22.1046 3.89543 23 5 23Z",
    fill: "#EE8003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C25.1046 4 26 3.10457 26 2C26 0.89543 25.1046 0 24 0C22.8954 0 22 0.89543 22 2C22 3.10457 22.8954 4 24 4Z",
    fill: "#EE8003"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.435 36.435C38.5396 36.435 39.435 35.5396 39.435 34.435C39.435 33.3304 38.5396 32.435 37.435 32.435C36.3304 32.435 35.435 33.3304 35.435 34.435C35.435 35.5396 36.3304 36.435 37.435 36.435Z",
    fill: "#EE8003"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.565 9.565C11.6696 9.565 12.565 8.66957 12.565 7.565C12.565 6.46043 11.6696 5.565 10.565 5.565C9.46043 5.565 8.565 6.46043 8.565 7.565C8.565 8.66957 9.46043 9.565 10.565 9.565Z",
    fill: "#EE8003"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.565 36.435C11.6696 36.435 12.565 35.5396 12.565 34.435C12.565 33.3304 11.6696 32.435 10.565 32.435C9.46043 32.435 8.565 33.3304 8.565 34.435C8.565 35.5396 9.46043 36.435 10.565 36.435Z",
    fill: "#EE8003"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.435 9.565C38.5396 9.565 39.435 8.66957 39.435 7.565C39.435 6.46043 38.5396 5.565 37.435 5.565C36.3304 5.565 35.435 6.46043 35.435 7.565C35.435 8.66957 36.3304 9.565 37.435 9.565Z",
    fill: "#EE8003"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.5e7b8aeeda94c1364533d9ca903e81a7.svg";
export { ForwardRef as ReactComponent };